import { ColorFresnelModel } from './color-fresnel.model';
import { ScalarFresnelModel } from './scalar-fresnel.model';
var ColorRecipeModel = /** @class */ (function () {
    // color mods
    function ColorRecipeModel(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.tintColor, tintColor = _c === void 0 ? null : _c, _d = _b.saturation, saturation = _d === void 0 ? null : _d, _e = _b.contrast, contrast = _e === void 0 ? null : _e, _f = _b.brightness, brightness = _f === void 0 ? null : _f, _g = _b.opacity, opacity = _g === void 0 ? null : _g, _h = _b.pickable, pickable = _h === void 0 ? true : _h;
        this.tintColor = tintColor || false;
        this.saturation = saturation || false;
        this.contrast = contrast || false;
        this.brightness = brightness || false;
        this.opacity = opacity || false;
    }
    ColorRecipeModel.toEngine = function (recipe) {
        var engineRecipe = {
            tintColor: false,
            saturation: false,
            brightness: false,
            contrast: false,
            opacity: false
        };
        // tint-color
        if (Array.isArray(recipe.tintColor)) {
            engineRecipe.tintColor = recipe.tintColor.map(function (rgb255) { return rgb255; });
        }
        else if (recipe.tintColor && recipe.tintColor instanceof ColorFresnelModel) {
            engineRecipe.tintColor = ColorFresnelModel.toEngine(recipe.tintColor);
        }
        // saturation 
        if (typeof recipe.saturation === 'number') {
            engineRecipe.saturation = Number(recipe.saturation) / 100.0;
        }
        else if (recipe.saturation instanceof ScalarFresnelModel) {
            engineRecipe.saturation = ScalarFresnelModel.toEngine(recipe.saturation);
        }
        // brightness 
        if (typeof recipe.brightness === 'number') {
            engineRecipe.brightness = Number(recipe.brightness) / 100.0;
        }
        else if (recipe.brightness instanceof ScalarFresnelModel) {
            engineRecipe.brightness = ScalarFresnelModel.toEngine(recipe.brightness);
        }
        // contrast 
        if (typeof recipe.contrast === 'number') {
            engineRecipe.contrast = Number(recipe.contrast) / 100.0;
        }
        else if (recipe.contrast instanceof ScalarFresnelModel) {
            engineRecipe.contrast = ScalarFresnelModel.toEngine(recipe.contrast);
        }
        // opacity 
        if (typeof recipe.opacity === 'number') {
            engineRecipe.opacity = Number(recipe.opacity) / 100.0;
        }
        else if (recipe.opacity instanceof ScalarFresnelModel) {
            engineRecipe.opacity = ScalarFresnelModel.toEngine(recipe.opacity);
        }
        return engineRecipe;
    };
    return ColorRecipeModel;
}());
export { ColorRecipeModel };
